<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" epub:type="pagebreak" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfmf"><a class="xref" href="#/chidunbarhester0007#pref">Preface</a></p>
<p class="tocf"><a class="xref" href="#/chidunbarhester0008#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chidunbarhester0009#ch01">1: Precariously Perched in a Port</a></p>
<p class="toc"><a class="xref" href="#/chidunbarhester0010#ch02">2: Yes, We Have No Bananas</a></p>
<p class="toc"><a class="xref" href="#/chidunbarhester0011#ch03">3: Coastal Translocations</a></p>
<p class="toc"><a class="xref" href="#/chidunbarhester0012#ch04">4: Aqua Nullius</a></p>
<p class="toc"><a class="xref" href="#/chidunbarhester0013#conc">Conclusion: Flux: Bridging to Futures</a></p>
<p class="tocbmf"><a class="xref" href="#/chidunbarhester0014#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chidunbarhester0015#app">Appendix: Timeline of Legislation and Events</a></p>
<p class="tocbm"><a class="xref" href="#/chidunbarhester0016#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chidunbarhester0018#biblio">Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chidunbarhester0019#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-dunbar-hester-0006.vue?38862f8f